import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AutocompleteBottomSheet } from './AutocompleteBottomSheet';
export function deriveAutocompleteDisplayValue(props) {
    var _props_inputValue;
    if (props.multiple && Array.isArray(props.value)) {
        return props.value.map((v)=>{
            var _props_getOptionLabel;
            return ((_props_getOptionLabel = props.getOptionLabel) !== null && _props_getOptionLabel !== void 0 ? _props_getOptionLabel : String)(v);
        }).join(', ');
    }
    if (props.value != null) {
        var _props_getOptionLabel;
        return ((_props_getOptionLabel = props.getOptionLabel) !== null && _props_getOptionLabel !== void 0 ? _props_getOptionLabel : String)(props.value);
    }
    return (_props_inputValue = props.inputValue) !== null && _props_inputValue !== void 0 ? _props_inputValue : '';
}
export function buildAutocompleteBottomSheet(props) {
    return /*#__PURE__*/ _jsx(AutocompleteBottomSheet, {
        options: props.options,
        getOptionLabel: props.getOptionLabel,
        renderOption: props.renderOption,
        filterOptions: props.filterOptions,
        getOptionDisabled: props.getOptionDisabled,
        getOptionSelected: props.getOptionSelected,
        onChange: props.onChange,
        onInputChange: props.onInputChange,
        value: props.value,
        inputValue: props.inputValue,
        multiple: props.multiple,
        freeSolo: props.freeSolo,
        filterSelectedOptions: props.filterSelectedOptions,
        loading: props.loading,
        noOptionsText: props.noOptionsText,
        label: props.label,
        testId: props.testId,
        disableCloseOnSelect: props.disableCloseOnSelect,
        popoverFooter: props.popoverFooter
    });
}
